// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".applications[data-v-2a55c9de]{padding-top:0;position:absolute;width:350px;top:330px}.applications strong[data-v-2a55c9de]{color:#8237dc}.applicationsSubTitle[data-v-2a55c9de]{color:#471782}.statusBtn[data-v-2a55c9de]{margin-top:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
